<h2  style="min-width: 80vw" mat-dialog-title>Manage Tags</h2>

<div class="ag-theme-alpine tag-grid">
    <ag-grid-angular
            style="width: 100%; height: 400px;"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            (cellClicked)="onCellClicked($event)"
            [rowSelection]="'single'"
            [domLayout]="'autoHeight'"
            [suppressRowClickSelection]="true"
            [animateRows]="true"
    ></ag-grid-angular>
</div>

<div class="add-tag-row">
    <input matInput placeholder="New tag" [(ngModel)]="newTag" (keydown.enter)="addNewTag()" />
    <button mat-raised-button color="primary" (click)="addNewTag()" [disabled]="!newTag.trim()">Add</button>
</div>

<div class="actions">
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onSave()">Save</button>
</div>
